<template lang="pug">
.leasing-comparator
	.section.section--white(v-if="isError")
		LeasingComparatorError
	template(v-else)
		.section.section--white
			.leasing-comparator__form
				LeasingComparatorForm(@error="showError")
		.leasing-comparator__result.section(ref="resultRef", aria-live="polite")
			LeasingComparatorResult(v-if="result.leasingComparationList.length", @error="showError")
</template>

<script setup>
import { nextTick, ref, watch } from 'vue';
import LeasingComparatorForm from './components/leasing-comparator-form.vue';
import LeasingComparatorResult from './components/leasing-comparator-result.vue';
import LeasingComparatorError from './components/leasing-comparator-error.vue';
import leasingComparatorApi from '../../api/leasing-comparator-api';
import { useStore } from './store';

const { result } = useStore();

const isError = ref(false);
const showError = () => {
	isError.value = true;
};

const resultRef = ref(null);
watch(result, async () => {
	await nextTick();
	resultRef.value.scrollIntoView({ behavior: 'smooth' });
});
</script>

<style lang="scss" scoped>
.leasing-comparator {
	position: relative;
	z-index: 1;
}
</style>
